export default "__VITE_ASSET__D1kBqg1F__"